'use es6';

class Category {
  constructor({
    description,
    label,
    toggleLabel
  }) {
    this.description = description;
    this.label = label;
    this.toggleLabel = toggleLabel;
  }
}
export default class CookiesByCategory {
  constructor({
    acceptAllLabel,
    categories,
    cookieSettingsLabel,
    introduction,
    saveSettingsLabel
  }) {
    this.acceptAllLabel = acceptAllLabel;
    this.cookieSettingsLabel = cookieSettingsLabel;
    this.saveSettingsLabel = saveSettingsLabel;
    this.introduction = new Category(introduction);
    this.categories = {
      necessary: new Category(categories.necessary),
      analytics: new Category(categories.analytics),
      advertisement: new Category(categories.advertisement),
      functionality: new Category(categories.functionality)
    };
  }
  static build(data) {
    if (!data) {
      return null;
    }
    return new CookiesByCategory(data);
  }
}